import script from "./OrderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderView.vue?vue&type=script&setup=true&lang=ts"

import "./OrderView.vue?vue&type=style&index=0&id=4e0cda58&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0cda58"]])

export default __exports__